import type {
  ApplicantAddressesPayload,
  ApplicantIncomePayload,
  ApplicantOutgoingsPayload,
  ApplicantPersonalDetailsPayloadUK,
  ApplicantResponseUK,
} from '@/api/UK/applicants/types';
import { apiRequest } from '@/api/utils/api';

export const createApplicant = (payload: ApplicantPersonalDetailsPayloadUK) =>
  apiRequest<ApplicantResponseUK>({ url: '/uk/applicants', method: 'POST', data: payload });

export const updateApplicant = (applicantId: string, payload: ApplicantPersonalDetailsPayloadUK) =>
  apiRequest<ApplicantResponseUK>({ url: `/uk/applicants/${applicantId}`, method: 'PUT', data: payload });

export const getApplicant = (applicantId: string) =>
  apiRequest<ApplicantResponseUK>({ url: `/uk/applicants/${applicantId}`, method: 'GET' });

export const updateApplicantAddresses = (applicantId: string, payload: ApplicantAddressesPayload) =>
  apiRequest<ApplicantResponseUK>({
    url: `/uk/applicants/${applicantId}/addresses`,
    method: 'PUT',
    data: payload,
  });

export const updateApplicantIncome = (applicantId: string, payload: ApplicantIncomePayload) =>
  apiRequest<ApplicantResponseUK>({
    url: `/uk/applicants/${applicantId}/income`,
    method: 'PUT',
    data: payload,
  });

export const updateApplicantOutgoings = (applicantId: string, payload: ApplicantOutgoingsPayload) =>
  apiRequest<ApplicantResponseUK>({
    url: `/uk/applicants/${applicantId}/outgoings`,
    method: 'PUT',
    data: payload,
  });
